import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
import axios from 'axios';
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: '',
        description: '',
        vip_level_required: '',
        division_id: '',
        reward_group_id: '',
        capacity: '',
        start_time: '',
        end_time: ''
      },
      rewardList: [],
      divisionList: [],
      rules: {
        description: [{
          required: true,
          message: "请填写",
          trigger: "change"
        }],
        vip_level_required: [{
          required: true,
          message: "请填写",
          trigger: "change"
        }],
        reward_group_id: [{
          required: true,
          message: "请选择",
          trigger: "change"
        }],
        division_id: [{
          required: true,
          message: "请选择",
          trigger: "change"
        }],
        capacity: [{
          required: true,
          message: "请填写",
          trigger: "change"
        }],
        start_time: [{
          required: true,
          message: "请选择",
          trigger: "change"
        }],
        end_time: [{
          required: true,
          message: "请选择",
          trigger: "change"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas, id, description, vip_level_required, division_id, reward_group_id, capacity, start_time, end_time;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getRewardData();

              case 2:
                _context.next = 4;
                return _this.getDivisionData();

              case 4:
                if (data) {
                  _this.copyPrimitive();

                  datas = JSON.parse(JSON.stringify(data));
                  id = datas.id, description = datas.description, vip_level_required = datas.vip_level_required, division_id = datas.division_id, reward_group_id = datas.reward_group_id, capacity = datas.capacity, start_time = datas.start_time, end_time = datas.end_time;
                  _this.formData = {
                    id: id,
                    description: description,
                    vip_level_required: vip_level_required,
                    division_id: division_id,
                    reward_group_id: reward_group_id,
                    capacity: capacity,
                    start_time: start_time,
                    end_time: end_time
                  };

                  _this.copyData();
                }

                _this.dialogFormVisible = true;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
    },
    getRewardData: function getRewardData() {
      var _this2 = this;

      this.$api.rewardList({
        page_size: -1
      }).then(function (res) {
        if (res.code == 200) {
          _this2.rewardList = res.data;
        }
      });
    },
    getDivisionData: function getDivisionData() {
      var _this3 = this;

      this.$api.divisionList({
        page_size: -1
      }).then(function (res) {
        if (res.code == 200) {
          _this3.divisionList = res.data;
        }
      });
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("this.formData==", _this4.formData);

                _this4.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    // this.formData.start_time =  this.formData.searchDateArr[0];
                    // this.formData.end_time =  this.formData.searchDateArr[1];
                    var data = JSON.parse(JSON.stringify(_this4.formData));

                    _this4.$api.eventSave(data).then(function (res) {
                      if (res.code == 200) {
                        var getData = res.data;

                        if (!_this4.formData.id) {
                          _this4.$api.codeGenerate({
                            count: getData.capacity,
                            event_id: getData.id
                          }).then(function (reqs) {
                            if (reqs.code == 200) {
                              _this4.$message.success('添加成功');
                            } else {
                              _this4.$message.error(reqs.msg);
                            }
                          });
                        } else {
                          _this4.$message.success('修改成功');
                        }

                        _this4.$emit('change');

                        _this4.dialogFormVisible = false;
                      } else {
                        _this4.$message.error(res.msg);
                      }
                    });
                  }
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};